export default "__VITE_ASSET__CwBuOWhM__"